import { FC } from "react";
import { CheckIcon, MinusIcon } from "@heroicons/react/solid";
import { CheckboxIconProps } from "./types";

const CheckboxIcon: FC<CheckboxIconProps> = ({ selected }) => {
  if (selected === "checked") {
    return (
      <CheckIcon
        className="absolute scale-75 pointer-events-none"
        fill="white"
      />
    );
  }

  if (selected === "allChecked") {
    return (
      <MinusIcon
        className="absolute scale-75 pointer-events-none"
        fill="white"
      />
    );
  }

  return null;
};

export default CheckboxIcon;
